import { graphql } from "~/gql";

export const DISBURSEMENT_FRAGMENT = graphql(/* GraphQL */ `
  fragment DisbursementParts on Disbursement {
    id
    name
    amount
    vatStatus
    order
    updatedAt
  }
`);
